import axios from "axios";
import jwt_decode from "jwt-decode";

export const setAuthToken = token => {
    if (token) {
        // Apply authorization token to every request if logged in
        axios.defaults.headers.common["Authorization"] = token;
    } else {
        // Delete auth header
        delete axios.defaults.headers.common["Authorization"];
    }
};


export const isTokenValid = token => {
    const decoded = jwt_decode(token);
    if(decoded.exp > Date.now()) {
        return {
            isValid: true,
            data: decoded
        }
    }
    return {
        isValid: false,
        data: null,
    }
}

